<template>

<v-container fluid class="pa-0">

 <v-container style="padding-bottom:64px;" class="max_width">

    <v-row style="height:64px"></v-row>

    <v-card-title class="display-1 pl-0 pt-0 mb-4 white--text font-weight-bold">Site Dashboard</v-card-title>

    <v-card-subtitle class="pl-0 white--text font-weight-medium pa-0 mb-3" >Create a site or navigate through your sites</v-card-subtitle>

    <v-card flat color="transparent" class="px-0 pt-0 pb-4">

      <v-btn rounded color="rgb(255, 0, 0, 0.1)" class="font-weight-medium white--text elevation-0 mr-2 my-1 pl-2 pr-4" @click="$router.push('/')"><v-icon small class="mr-2">mdi-arrow-left</v-icon>Back to Dashboard</v-btn>

    </v-card>

    <section>
         

          <!-- contains buttons for site dashboard, only loads once data has been retrieved -->
          <v-row v-if="!isFetching">

            <v-dialog
              v-model="dialog"
              persistent
              max-width="600px"
              >
      <template v-slot:activator="{ on, attrs }">
        
          <v-col class="pt-0 mb-3" cols="12" sm="6" md="4">
            
              <v-card class='elevation-2 justify-center' align="center" height="200px" style="display:flex; flex-direction:column;" v-bind="attrs"
          v-on="on" >

                <v-container >

                  <v-icon x-large color="primary">mdi-plus</v-icon>

                  <v-card-text class="body-2 primary--text">Create a Site</v-card-text>
                
                </v-container>

            </v-card>

            </v-col>
        
      </template>

      <v-card>

        <v-card-text class="pb-0">

          <v-container>

            <v-card-actions class="pl-0 pr-0">

              <v-card-title class="font-weight-bold pl-0">Site Creation</v-card-title>

              <v-spacer></v-spacer>

              <v-btn icon @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>

            </v-card-actions>

            <v-row>
              
              <v-col cols="12">

                <v-text-field
                  dense
                  label="Enter your site name*"
                  required
                  v-model="siteName"
                ></v-text-field>

              </v-col>

              <v-col cols="12">

                <v-text-field
                  dense
                  label="Address*"
                  required
                  id="address"
                  v-model="siteAddress"
                ></v-text-field>

              </v-col>
              
            </v-row>

          </v-container>

        </v-card-text>

        <v-card-actions>

          <v-card-text class="caption grey--text text--darken-1">*indicates required field</v-card-text>

          <v-spacer></v-spacer>

          <v-btn
            color="primary"
            text
            @click="dialog = false"
            class="font-weight-medium"
          >
            Close
          </v-btn>
          <v-btn
            color="primary"
            text
            @click="createNewSite()"
            class="font-weight-medium"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
      
    </v-dialog>


            <v-col class="pt-0 mb-3"  v-for="item in sites" :key="item" @click="$router.push({ path: 'site-control', query: { site: item['id'] } })" cols="12" sm="6" md="4">

            <!--This repeats for each site on Firestore -->  
            
              <v-card class='elevation-2' style="display:flex; flex-direction:column" height="200px">

                <v-card-title class="font-weight-medium black--text">{{item['name']}}</v-card-title>

                <v-card-subtitle class="body-2">Add a little info here</v-card-subtitle>

                <v-spacer></v-spacer>
                
                <v-card-actions>

                  <v-btn rounded color="primary" class="font-weight-medium elevation-0">Edit Site</v-btn>

                  <v-btn rounded disabled color="primary" class="font-weight-medium elevation-0">Induction Invite</v-btn>

                </v-card-actions>

              </v-card>

            </v-col>
            
          </v-row>

    </section>

  </v-container>

</v-container>

</template>

<script>

import { mapState } from 'vuex'
import moment from 'moment'

export default {
  
  

  data() {

    return {
      post: {
        content: ''
      },
      showCommentModal: false,
      selectedPost: {},
      showPostModal: false,
      fullPost: {},
      postComments: [],
      sites: [],
      isFetching: true,
      dialog: false,
       
    }
  },
  computed: {
    ...mapState(['userProfile', 'posts', 'userRole', 'userId']),


  },
  
  methods: {
   
    createNewSite() {
      
       this.$store.dispatch('addSite',{
         siteName: this.siteName, siteAddress: this.siteAddress

       }).then(this.getSites())
       .then(this.dialog = false)
       
    },

    openSiteDash(event) {
      alert(event)
    },

    createPost() {
      this.$store.dispatch('createPost', { content: this.post.content })
      this.post.content = ''
    },
    toggleCommentModal(post) {
      this.showCommentModal = !this.showCommentModal

      // if opening modal set selectedPost, else clear
      if (this.showCommentModal) {
        this.selectedPost = post
      } else {
        this.selectedPost = {}
      }
    },
    
    closePostModal() {
      this.postComments = []
      this.showPostModal = false
    },

    async getSites() {
      this.sites = []
      
      const docs = await sitesCollection.where("viewers","array-contains", this.userId ).get()
      
      docs.forEach(doc => {
        let site = {"id":doc.id, "name":doc.data().name}
        this.sites.push(site) 
      },
      
      this.isFetching = false)

    }

  },


  beforeMount(){
    this.getSites()
  },
  filters: {
    formatDate(val) {
      if (!val) { return '-' }

      let date = val.toDate()
      return moment(date).fromNow()
    },
    trimLength(val) {
      if (val.length < 200) { return val }
      return `${val.substring(0, 200)}...`
    }
  },
  

    
}
</script>

<style lang="scss" scoped>

</style>
